import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { EmployeeLinkFieldWithAccessCheck } from 'domain/shared/employee';
import { useShowContext } from 'framework/show';
import { MentorIcon } from 'framework/ui/mui-builder';
import { SxProps } from '@mui/material';

const MentorInfo = ({ sxWrap = {} }: { sxWrap?: SxProps }) => {
  const { data: employee } = useShowContext();
  const mentor: string = employee?.employeeMentor || employee?.mentorshipInformation?.mentor || '';

  return (
    <Box sx={{ mt: 1, display: 'flex', flexDirection: 'row', ...sxWrap }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
        <MentorIcon titleAccess="Mentor" sx={{ height: '24px', width: '24px' }} />
        {mentor.length > 0 ? (
          <Box>
            <EmployeeLinkFieldWithAccessCheck externalId={mentor} sx={{ lineHeight: '20px' }} />
          </Box>
        ) : (
          <Typography variant="body1" color="textSecondary" fontStyle="italic">
            No mentors assigned
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default MentorInfo;
